<template>
    <div id="previewContainer">
        <code v-html="content"></code>
    </div>
</template>
<script type="javascript">

    export default {
        name: 'EditorPreview',
        props: ['froalaId'],
        components: { },
        data() {
            return {
                refreshArticle: {},
                content: ''
            }
        },
        methods: {
            transformHtml(content){

                let regex = /<a href="(.*?)">(.*?)<\/a>/ig;

                return content.replace(regex,($1,$2) => {

                    let removeTag = /(<([^>]+)>)/ig;
                    let body = $1.replace(removeTag, "");

                    return "<span class='dict-button' onclick=\"alert('" + decodeURIComponent($2) + "')\">" + body + "</span>"
                })
            }
        },
        mounted(){
            this.refreshArticle = setInterval(() => {
                let _content = document.getElementById(this.froalaId).value.replace(/&nbsp;/gi,' ')
                this.content = this.transformHtml(_content)

            }, 2000);
        },
        beforeDestroy() {
            clearInterval(this.refreshArticle);
        },
        beforeRouteUpdate(to, from, next) {
            if (to.name === from.name && from.params.id && !to.params.id) {
                clearInterval(this.refreshArticle);
            }

            next();
        }
    }

</script>

<style>
    .dict-button{
        background-color: #ffffff;
        -moz-border-radius: 28px;
        -webkit-border-radius: 28px;
        border-radius: 28px;
        border: 1px solid #000000;
        display: inline-block;
        cursor: pointer;
        color: #000000;
        font-family: Arial;
        font-size: 15px;
        padding: 0px 24px;
        text-decoration: none;
    }

    #previewContainer {
        border: 1px solid #483f3f73;
        box-shadow: 2px 2px #e2dcdc;
        padding: 10px;
    }

</style>


// WEBPACK FOOTER //
// resources/vue/editor-preview.vue